/* unplugin-vue-components disabled */import { render } from "./BindPhone.vue?vue&type=template&id=c6f24672&scoped=true"
import script from "./BindPhone.vue?vue&type=script&lang=js"
export * from "./BindPhone.vue?vue&type=script&lang=js"

import "./BindPhone.vue?vue&type=style&index=0&id=c6f24672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f24672"]])

export default __exports__